import { Languages } from './codeLanguageConstants';
import { getUnifiedCodeLanguageId } from './getUnifiedCodeLanguageId';

export const getUnifiedCodeLanguage = (value: string) => {
  return Languages.find(
    ({ name }) =>
      getUnifiedCodeLanguageId(name.toLocaleLowerCase()) ===
      getUnifiedCodeLanguageId(value.toLocaleLowerCase()),
  );
};
